"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _get = _interopRequireDefault(require("lodash/get"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _get_day = _interopRequireDefault(require("date-fns/get_day"));
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _is_same_month = _interopRequireDefault(require("date-fns/is_same_month"));
var _start_of_day = _interopRequireDefault(require("date-fns/start_of_day"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _Day = _interopRequireDefault(require("./Day"));
var _MonthSelector = _interopRequireDefault(require("./MonthSelector"));
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/Calendar.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_26134e7pkr() {
  var path = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/Calendar.js";
  var hash = "c565215140639ad4f48eedeeed5d25f9467a79e5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/Calendar.js",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 23
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "1": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 88
        }
      },
      "2": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 95
        }
      },
      "3": {
        start: {
          line: 61,
          column: 17
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "4": {
        start: {
          line: 71,
          column: 35
        },
        end: {
          line: 71,
          column: 80
        }
      },
      "5": {
        start: {
          line: 80,
          column: 16
        },
        end: {
          line: 96,
          column: 1
        }
      },
      "6": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 88
        }
      },
      "7": {
        start: {
          line: 98,
          column: 16
        },
        end: {
          line: 118,
          column: 1
        }
      },
      "8": {
        start: {
          line: 120,
          column: 20
        },
        end: {
          line: 144,
          column: 2
        }
      },
      "9": {
        start: {
          line: 146,
          column: 20
        },
        end: {
          line: 152,
          column: 1
        }
      },
      "10": {
        start: {
          line: 147,
          column: 2
        },
        end: {
          line: 151,
          column: 16
        }
      },
      "11": {
        start: {
          line: 154,
          column: 0
        },
        end: {
          line: 156,
          column: 2
        }
      },
      "12": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 17
        }
      },
      "13": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 170,
          column: 6
        }
      },
      "14": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 51
        }
      },
      "15": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 62
        }
      },
      "16": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 18
        }
      },
      "17": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 65
        }
      },
      "18": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 186,
          column: 5
        }
      },
      "19": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 185,
          column: 30
        }
      },
      "20": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 28
        }
      },
      "21": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 197,
          column: 5
        }
      },
      "22": {
        start: {
          line: 192,
          column: 6
        },
        end: {
          line: 192,
          column: 37
        }
      },
      "23": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 196,
          column: 9
        }
      },
      "24": {
        start: {
          line: 201,
          column: 23
        },
        end: {
          line: 201,
          column: 47
        }
      },
      "25": {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 206,
          column: 5
        }
      },
      "26": {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 205,
          column: 9
        }
      },
      "27": {
        start: {
          line: 209,
          column: 18
        },
        end: {
          line: 209,
          column: 56
        }
      },
      "28": {
        start: {
          line: 210,
          column: 28
        },
        end: {
          line: 210,
          column: 98
        }
      },
      "29": {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 287,
          column: 6
        }
      },
      "30": {
        start: {
          line: 216,
          column: 41
        },
        end: {
          line: 216,
          column: 80
        }
      },
      "31": {
        start: {
          line: 225,
          column: 14
        },
        end: {
          line: 227,
          column: 24
        }
      },
      "32": {
        start: {
          line: 232,
          column: 12
        },
        end: {
          line: 232,
          column: 32
        }
      },
      "33": {
        start: {
          line: 236,
          column: 35
        },
        end: {
          line: 236,
          column: 40
        }
      },
      "34": {
        start: {
          line: 237,
          column: 12
        },
        end: {
          line: 283,
          column: 14
        }
      },
      "35": {
        start: {
          line: 241,
          column: 34
        },
        end: {
          line: 241,
          column: 59
        }
      },
      "36": {
        start: {
          line: 242,
          column: 32
        },
        end: {
          line: 242,
          column: 54
        }
      },
      "37": {
        start: {
          line: 243,
          column: 35
        },
        end: {
          line: 243,
          column: 93
        }
      },
      "38": {
        start: {
          line: 245,
          column: 20
        },
        end: {
          line: 245,
          column: 50
        }
      },
      "39": {
        start: {
          line: 246,
          column: 37
        },
        end: {
          line: 246,
          column: 64
        }
      },
      "40": {
        start: {
          line: 247,
          column: 18
        },
        end: {
          line: 247,
          column: 68
        }
      },
      "41": {
        start: {
          line: 248,
          column: 33
        },
        end: {
          line: 260,
          column: 19
        }
      },
      "42": {
        start: {
          line: 261,
          column: 18
        },
        end: {
          line: 270,
          column: 19
        }
      },
      "43": {
        start: {
          line: 262,
          column: 20
        },
        end: {
          line: 269,
          column: 22
        }
      },
      "44": {
        start: {
          line: 271,
          column: 18
        },
        end: {
          line: 271,
          column: 32
        }
      },
      "45": {
        start: {
          line: 291,
          column: 0
        },
        end: {
          line: 324,
          column: 2
        }
      },
      "46": {
        start: {
          line: 326,
          column: 0
        },
        end: {
          line: 336,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 34,
            column: 22
          },
          end: {
            line: 34,
            column: 23
          }
        },
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 88
          }
        },
        line: 35
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 26
          },
          end: {
            line: 37,
            column: 27
          }
        },
        loc: {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 95
          }
        },
        line: 38
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 26
          },
          end: {
            line: 71,
            column: 27
          }
        },
        loc: {
          start: {
            line: 71,
            column: 35
          },
          end: {
            line: 71,
            column: 80
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 87,
            column: 22
          },
          end: {
            line: 87,
            column: 23
          }
        },
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 88
          }
        },
        line: 88
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 146,
            column: 20
          },
          end: {
            line: 146,
            column: 21
          }
        },
        loc: {
          start: {
            line: 147,
            column: 2
          },
          end: {
            line: 151,
            column: 16
          }
        },
        line: 147
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 3
          }
        },
        loc: {
          start: {
            line: 165,
            column: 21
          },
          end: {
            line: 172,
            column: 3
          }
        },
        line: 165
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 174,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        },
        loc: {
          start: {
            line: 174,
            column: 22
          },
          end: {
            line: 177,
            column: 3
          }
        },
        line: 174
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 179,
            column: 3
          }
        },
        loc: {
          start: {
            line: 179,
            column: 25
          },
          end: {
            line: 181,
            column: 3
          }
        },
        line: 179
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 183,
            column: 3
          }
        },
        loc: {
          start: {
            line: 183,
            column: 13
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 183
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        loc: {
          start: {
            line: 190,
            column: 20
          },
          end: {
            line: 198,
            column: 3
          }
        },
        line: 190
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 200,
            column: 3
          }
        },
        loc: {
          start: {
            line: 200,
            column: 11
          },
          end: {
            line: 207,
            column: 3
          }
        },
        line: 200
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 208,
            column: 2
          },
          end: {
            line: 208,
            column: 3
          }
        },
        loc: {
          start: {
            line: 208,
            column: 11
          },
          end: {
            line: 288,
            column: 3
          }
        },
        line: 208
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 216,
            column: 24
          },
          end: {
            line: 216,
            column: 25
          }
        },
        loc: {
          start: {
            line: 216,
            column: 41
          },
          end: {
            line: 216,
            column: 80
          }
        },
        line: 216
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 224,
            column: 25
          },
          end: {
            line: 224,
            column: 26
          }
        },
        loc: {
          start: {
            line: 225,
            column: 14
          },
          end: {
            line: 227,
            column: 24
          }
        },
        line: 225
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 231,
            column: 20
          },
          end: {
            line: 231,
            column: 21
          }
        },
        loc: {
          start: {
            line: 231,
            column: 28
          },
          end: {
            line: 233,
            column: 11
          }
        },
        line: 231
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 235,
            column: 20
          },
          end: {
            line: 235,
            column: 21
          }
        },
        loc: {
          start: {
            line: 235,
            column: 28
          },
          end: {
            line: 284,
            column: 11
          }
        },
        line: 235
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 240,
            column: 25
          },
          end: {
            line: 240,
            column: 26
          }
        },
        loc: {
          start: {
            line: 240,
            column: 32
          },
          end: {
            line: 272,
            column: 17
          }
        },
        line: 240
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 13
          }
        }, {
          start: {
            line: 35,
            column: 17
          },
          end: {
            line: 35,
            column: 28
          }
        }, {
          start: {
            line: 35,
            column: 32
          },
          end: {
            line: 35,
            column: 52
          }
        }, {
          start: {
            line: 35,
            column: 56
          },
          end: {
            line: 35,
            column: 88
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 13
          }
        }, {
          start: {
            line: 38,
            column: 17
          },
          end: {
            line: 38,
            column: 28
          }
        }, {
          start: {
            line: 38,
            column: 32
          },
          end: {
            line: 38,
            column: 52
          }
        }, {
          start: {
            line: 38,
            column: 56
          },
          end: {
            line: 38,
            column: 95
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 13
          }
        }, {
          start: {
            line: 88,
            column: 17
          },
          end: {
            line: 88,
            column: 28
          }
        }, {
          start: {
            line: 88,
            column: 32
          },
          end: {
            line: 88,
            column: 52
          }
        }, {
          start: {
            line: 88,
            column: 56
          },
          end: {
            line: 88,
            column: 88
          }
        }],
        line: 88
      },
      "3": {
        loc: {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 184
      },
      "4": {
        loc: {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 197,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 197,
            column: 5
          }
        }, {
          start: {
            line: 193,
            column: 11
          },
          end: {
            line: 197,
            column: 5
          }
        }],
        line: 191
      },
      "5": {
        loc: {
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 206,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 202
      },
      "6": {
        loc: {
          start: {
            line: 210,
            column: 28
          },
          end: {
            line: 210,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 210,
            column: 28
          },
          end: {
            line: 210,
            column: 50
          }
        }, {
          start: {
            line: 210,
            column: 54
          },
          end: {
            line: 210,
            column: 98
          }
        }],
        line: 210
      },
      "7": {
        loc: {
          start: {
            line: 222,
            column: 11
          },
          end: {
            line: 228,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 11
          },
          end: {
            line: 222,
            column: 33
          }
        }, {
          start: {
            line: 224,
            column: 12
          },
          end: {
            line: 228,
            column: 14
          }
        }],
        line: 222
      },
      "8": {
        loc: {
          start: {
            line: 243,
            column: 35
          },
          end: {
            line: 243,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 243,
            column: 35
          },
          end: {
            line: 243,
            column: 69
          }
        }, {
          start: {
            line: 243,
            column: 73
          },
          end: {
            line: 243,
            column: 93
          }
        }],
        line: 243
      },
      "9": {
        loc: {
          start: {
            line: 244,
            column: 26
          },
          end: {
            line: 244,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 244,
            column: 36
          },
          end: {
            line: 244,
            column: 38
          }
        }],
        line: 244
      },
      "10": {
        loc: {
          start: {
            line: 244,
            column: 40
          },
          end: {
            line: 244,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 244,
            column: 49
          },
          end: {
            line: 244,
            column: 51
          }
        }],
        line: 244
      },
      "11": {
        loc: {
          start: {
            line: 245,
            column: 20
          },
          end: {
            line: 245,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 20
          },
          end: {
            line: 245,
            column: 44
          }
        }, {
          start: {
            line: 245,
            column: 48
          },
          end: {
            line: 245,
            column: 50
          }
        }],
        line: 245
      },
      "12": {
        loc: {
          start: {
            line: 247,
            column: 37
          },
          end: {
            line: 247,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 247,
            column: 37
          },
          end: {
            line: 247,
            column: 53
          }
        }, {
          start: {
            line: 247,
            column: 57
          },
          end: {
            line: 247,
            column: 67
          }
        }],
        line: 247
      },
      "13": {
        loc: {
          start: {
            line: 261,
            column: 18
          },
          end: {
            line: 270,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 261,
            column: 18
          },
          end: {
            line: 270,
            column: 19
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 261
      },
      "14": {
        loc: {
          start: {
            line: 261,
            column: 22
          },
          end: {
            line: 261,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 261,
            column: 22
          },
          end: {
            line: 261,
            column: 49
          }
        }, {
          start: {
            line: 261,
            column: 53
          },
          end: {
            line: 261,
            column: 74
          }
        }],
        line: 261
      },
      "15": {
        loc: {
          start: {
            line: 265,
            column: 25
          },
          end: {
            line: 267,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 265,
            column: 25
          },
          end: {
            line: 265,
            column: 52
          }
        }, {
          start: {
            line: 266,
            column: 26
          },
          end: {
            line: 266,
            column: 88
          }
        }],
        line: 265
      },
      "16": {
        loc: {
          start: {
            line: 273,
            column: 17
          },
          end: {
            line: 281,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 17
          },
          end: {
            line: 273,
            column: 33
          }
        }, {
          start: {
            line: 274,
            column: 18
          },
          end: {
            line: 274,
            column: 40
          }
        }, {
          start: {
            line: 275,
            column: 20
          },
          end: {
            line: 280,
            column: 37
          }
        }],
        line: 273
      },
      "17": {
        loc: {
          start: {
            line: 277,
            column: 23
          },
          end: {
            line: 279,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 277,
            column: 23
          },
          end: {
            line: 277,
            column: 50
          }
        }, {
          start: {
            line: 278,
            column: 24
          },
          end: {
            line: 278,
            column: 86
          }
        }],
        line: 277
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c565215140639ad4f48eedeeed5d25f9467a79e5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26134e7pkr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26134e7pkr();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// contains an inline box for the selected day
var DetailedBoxDay = (cov_26134e7pkr().s[0]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "g-calendar-detailedDay"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      border-width: 0 ", " ", " 0;\n      border-style: solid;\n      border-color: ", ";\n      position: relative;\n      background-color: ", ";\n      padding: 2.25rem 2.5rem 1.75rem 2.5rem;\n    "])), _stylingConstants.default.border.widthBase, _stylingConstants.default.border.widthBase, function (props) {
  cov_26134e7pkr().f[0]++;
  cov_26134e7pkr().s[1]++;
  return (cov_26134e7pkr().b[0][0]++, props) && (cov_26134e7pkr().b[0][1]++, props.theme) && (cov_26134e7pkr().b[0][2]++, props.theme.calendar) && (cov_26134e7pkr().b[0][3]++, props.theme.calendar.borderColor);
}, function (props) {
  cov_26134e7pkr().f[1]++;
  cov_26134e7pkr().s[2]++;
  return (cov_26134e7pkr().b[1][0]++, props) && (cov_26134e7pkr().b[1][1]++, props.theme) && (cov_26134e7pkr().b[1][2]++, props.theme.calendar) && (cov_26134e7pkr().b[1][3]++, props.theme.calendar.detailedDayBgColor);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      background: var(--itemRowBgColor, rgba(254,1,107,0.05));\n      border: none;\n      padding: var(--spacingX, 12px);\n\n      .stx-SectionContent {\n        margin: 0;\n      }\n\n      .showAsGrid.stx-SectionCluster {\n        .stx-ProductActions-BoxWrapper {\n          width: 100%;\n        }\n      }\n    "]))))));

// put border on the top left for the containder and for object inside
var FlexWeek = (cov_26134e7pkr().s[3]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "g-calendar-week"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, ''), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      color: ", ";\n      border-radius: ", "\n        ", " 0 0;\n      background-color: ", ";\n      border-top: none;\n      border-right: none;\n      border-left: none;\n      border-bottom: var(--dividerWidth) solid var(--dividerColor);\n    "])), _themeMapper.evolutionTheme.calendar.wrapper.color, _themeMapper.evolutionTheme.calendar.wrapper.borderRadius, _themeMapper.evolutionTheme.calendar.wrapper.borderRadius, function (props) {
  cov_26134e7pkr().f[2]++;
  cov_26134e7pkr().s[4]++;
  return (0, _get.default)(props, 'theme.contentBgColor', '#ffffff');
}))));
var Wrapper = (cov_26134e7pkr().s[5]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-calendar"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      border-width: ", " 0 0 ", ";\n      border-color: ", ";\n      border-style: solid;\n    "])), _stylingConstants.default.border.widthBase, _stylingConstants.default.border.widthBase, function (props) {
  cov_26134e7pkr().f[3]++;
  cov_26134e7pkr().s[6]++;
  return (cov_26134e7pkr().b[2][0]++, props) && (cov_26134e7pkr().b[2][1]++, props.theme) && (cov_26134e7pkr().b[2][2]++, props.theme.calendar) && (cov_26134e7pkr().b[2][3]++, props.theme.calendar.borderColor);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      border-bottom-left-radius: ", ";\n      border-bottom-right-radius: ", ";\n    "])), _themeMapper.evolutionTheme.calendar.wrapper.borderRadius, _themeMapper.evolutionTheme.calendar.wrapper.borderRadius))));
var WeekDay = (cov_26134e7pkr().s[7]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "g-calendar-weekDay"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: center;\n      padding: ", " 0 ", " 0;\n      text-transform: capitalize;\n    "])), _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.xsmall)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      padding: var(--spacingX, 12px);\n\n      > span {\n        font-size: ", ";\n        line-height: ", ";\n        font-weight: ", ";\n      }\n    "])), _themeMapper.evolutionTheme.typography.body2.fontSize, _themeMapper.evolutionTheme.typography.body2.lineHeight, _themeMapper.evolutionTheme.fontWeight.medium))));
var CloseDetail = (cov_26134e7pkr().s[8]++, (0, _utils.withThemedStyles)(_styledComponents.default.div, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      top: 0px;\n      right: 0px;\n      padding: ", ";\n      cursor: pointer;\n      z-index: 2;\n    "])), _stylingConstants.default.spacing.small)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      cursor: pointer;\n      z-index: 10;\n      border-radius: 9999px;\n      background-color: var(--secondaryColor);\n      color: var(--secondaryTextColor);\n      width: 40px;\n      .g-Button.g-Button-small {\n        border-radius: 9999px;\n      }\n  }\n    "]))))));
cov_26134e7pkr().s[9]++;
var CloseButton = function CloseButton(props) {
  cov_26134e7pkr().f[4]++;
  cov_26134e7pkr().s[10]++;
  return /*#__PURE__*/_react.default.createElement(CloseDetail, {
    className: "g-calendar-detailedDay-closeButton",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    small: true,
    flat: true,
    onClick: props.closeDetailedDay,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: "close",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 7
    }
  })));
};
cov_26134e7pkr().s[11]++;
CloseButton.propTypes = {
  closeDetailedDay: _propTypes.default.func.isRequired
};

/**
 * Calendar component that displays a grid of days in 7 columns
 * On mobile phone, show a list of days in one column
 *
 *
 */
var Calendar = /*#__PURE__*/function (_React$Component) {
  function Calendar(props) {
    var _this2;
    (0, _classCallCheck2.default)(this, Calendar);
    cov_26134e7pkr().f[5]++;
    cov_26134e7pkr().s[12]++;
    _this2 = _callSuper(this, Calendar, [props]);
    cov_26134e7pkr().s[13]++;
    _this2.state = {
      mobileView: false,
      month: props.month
    };
    cov_26134e7pkr().s[14]++;
    _this2.changeMonth = _this2.changeMonth.bind(_this2);
    return _this2;
  }
  (0, _inherits2.default)(Calendar, _React$Component);
  return (0, _createClass2.default)(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_26134e7pkr().f[6]++;
      cov_26134e7pkr().s[15]++;
      window.addEventListener('resize', this.update.bind(this));
      cov_26134e7pkr().s[16]++;
      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_26134e7pkr().f[7]++;
      cov_26134e7pkr().s[17]++;
      window.removeEventListener('resize', this.update.bind(this));
    }
  }, {
    key: "getMonth",
    value: function getMonth() {
      cov_26134e7pkr().f[8]++;
      cov_26134e7pkr().s[18]++;
      if (this.props.onMonthChange) {
        cov_26134e7pkr().b[3][0]++;
        cov_26134e7pkr().s[19]++;
        return this.props.month;
      } else {
        cov_26134e7pkr().b[3][1]++;
      }
      cov_26134e7pkr().s[20]++;
      return this.state.month;
    }
  }, {
    key: "changeMonth",
    value: function changeMonth(date) {
      cov_26134e7pkr().f[9]++;
      cov_26134e7pkr().s[21]++;
      if (this.props.onMonthChange) {
        cov_26134e7pkr().b[4][0]++;
        cov_26134e7pkr().s[22]++;
        this.props.onMonthChange(date);
      } else {
        cov_26134e7pkr().b[4][1]++;
        cov_26134e7pkr().s[23]++;
        this.setState({
          month: date
        });
      }
    }
  }, {
    key: "update",
    value: function update() {
      cov_26134e7pkr().f[10]++;
      var mobileView = (cov_26134e7pkr().s[24]++, window.innerWidth < 1024);
      cov_26134e7pkr().s[25]++;
      if (mobileView !== this.state.mobileView) {
        cov_26134e7pkr().b[5][0]++;
        cov_26134e7pkr().s[26]++;
        this.setState({
          mobileView: mobileView
        });
      } else {
        cov_26134e7pkr().b[5][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_26134e7pkr().f[11]++;
      var weeks = (cov_26134e7pkr().s[27]++, (0, _utils2.getCalendarDaysByWeek)(this.getMonth()));
      var detailedDayText = (cov_26134e7pkr().s[28]++, (cov_26134e7pkr().b[6][0]++, this.props.detailedDay) && (cov_26134e7pkr().b[6][1]++, (0, _format.default)(this.props.detailedDay, 'YYYY-MM-DD')));
      cov_26134e7pkr().s[29]++;
      return /*#__PURE__*/_react.default.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 212,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_MonthSelector.default, {
        selectedMonth: this.getMonth(),
        months: this.props.months,
        monthHandler: function monthHandler(year, month) {
          cov_26134e7pkr().f[12]++;
          cov_26134e7pkr().s[30]++;
          return _this3.changeMonth(new Date(year, month));
        },
        monthDetails: this.props.monthDetails,
        mobileView: this.state.mobileView,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213,
          columnNumber: 9
        }
      }), this.props.additionalChild, /*#__PURE__*/_react.default.createElement(FlexWeek, {
        wrap: "wrap",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 221,
          columnNumber: 9
        }
      }, (cov_26134e7pkr().b[7][0]++, !this.state.mobileView) && (cov_26134e7pkr().b[7][1]++,
      // generate the name of the day (monday / tuesday / ..). Use week day number as key
      weeks[0].map(function (day) {
        cov_26134e7pkr().f[13]++;
        cov_26134e7pkr().s[31]++;
        return /*#__PURE__*/_react.default.createElement(WeekDay, {
          w: [1 / 7],
          key: (0, _get_day.default)(day),
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 225,
            columnNumber: 15
          }
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
          value: day,
          weekday: "long",
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 226,
            columnNumber: 17
          }
        }));
      }))), /*#__PURE__*/_react.default.createElement(Wrapper, {
        innerRef: function innerRef(wrap) {
          cov_26134e7pkr().f[14]++;
          cov_26134e7pkr().s[32]++;
          _this3.wrapper = wrap;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 230,
          columnNumber: 9
        }
      },
      // for each week
      weeks.map(function (week) {
        cov_26134e7pkr().f[15]++;
        var foundDetailedDay = (cov_26134e7pkr().s[33]++, false);
        cov_26134e7pkr().s[34]++;
        return /*#__PURE__*/_react.default.createElement(FlexWeek, {
          wrap: "wrap",
          key: (0, _format.default)(week[0], 'YYYY-WW'),
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 238,
            columnNumber: 15
          }
        },
        // for each day
        week.map(function (day) {
          cov_26134e7pkr().f[16]++;
          var dayText = (cov_26134e7pkr().s[35]++, (0, _format.default)(day, 'YYYY-MM-DD'));
          var toDay = (cov_26134e7pkr().s[36]++, (0, _start_of_day.default)(new Date()));
          var disabled = (cov_26134e7pkr().s[37]++, (cov_26134e7pkr().b[8][0]++, !(0, _is_same_month.default)(day, _this3.getMonth())) || (cov_26134e7pkr().b[8][1]++, (0, _is_before.default)(day, toDay)));
          var _ref = (cov_26134e7pkr().s[38]++, (cov_26134e7pkr().b[11][0]++, _this3.props.days[dayText]) || (cov_26134e7pkr().b[11][1]++, {})),
            _ref$content = _ref.content,
            content = _ref$content === void 0 ? (cov_26134e7pkr().b[9][0]++, '') : _ref$content,
            _ref$footer = _ref.footer,
            footer = _ref$footer === void 0 ? (cov_26134e7pkr().b[10][0]++, '') : _ref$footer,
            indicator = _ref.indicator,
            onClick = _ref.onClick;
          var isSelected = (cov_26134e7pkr().s[39]++, dayText === detailedDayText);
          cov_26134e7pkr().s[40]++;
          foundDetailedDay = (cov_26134e7pkr().b[12][0]++, foundDetailedDay) || (cov_26134e7pkr().b[12][1]++, isSelected);
          var dayDef = (cov_26134e7pkr().s[41]++, [/*#__PURE__*/_react.default.createElement(_Day.default, {
            date: day,
            content: content,
            footer: footer,
            indicator: indicator,
            key: dayText,
            bigday: !_this3.state.mobileView,
            disabled: disabled,
            selected: isSelected,
            onClick: onClick,
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 249,
              columnNumber: 21
            }
          })]);
          cov_26134e7pkr().s[42]++;
          if ((cov_26134e7pkr().b[14][0]++, dayText === detailedDayText) && (cov_26134e7pkr().b[14][1]++, _this3.state.mobileView)) {
            cov_26134e7pkr().b[13][0]++;
            cov_26134e7pkr().s[43]++;
            dayDef.push(/*#__PURE__*/_react.default.createElement(DetailedBoxDay, {
              w: 1,
              key: detailedDayText,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 263,
                columnNumber: 23
              }
            }, _this3.props.detailedDayContent, (cov_26134e7pkr().b[15][0]++, _this3.props.closeDetailedDay) && (cov_26134e7pkr().b[15][1]++, /*#__PURE__*/_react.default.createElement(CloseButton, {
              closeDetailedDay: _this3.props.closeDetailedDay,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 266,
                columnNumber: 27
              }
            }))));
          } else {
            cov_26134e7pkr().b[13][1]++;
          }
          cov_26134e7pkr().s[44]++;
          return dayDef;
        }), (cov_26134e7pkr().b[16][0]++, foundDetailedDay) && (cov_26134e7pkr().b[16][1]++, !_this3.state.mobileView) && (cov_26134e7pkr().b[16][2]++, /*#__PURE__*/_react.default.createElement(DetailedBoxDay, {
          w: 1,
          key: detailedDayText,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 275,
            columnNumber: 21
          }
        }, _this3.props.detailedDayContent, (cov_26134e7pkr().b[17][0]++, _this3.props.closeDetailedDay) && (cov_26134e7pkr().b[17][1]++, /*#__PURE__*/_react.default.createElement(CloseButton, {
          closeDetailedDay: _this3.props.closeDetailedDay,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 278,
            columnNumber: 25
          }
        })))));
      })));
    }
  }]);
}((_react.default.Component));
cov_26134e7pkr().s[45]++;
Calendar.propTypes = {
  /** Pass the month for which we want to display the calendar */
  month: _propTypes.default.instanceOf(Date),
  /** Pass a function to be applied when another month is selected
   * if Provided the month property define the month displayed,
   * if not provided, the mont property is only the initialization
   * and the month displayed is handled by the component through the state
   */
  onMonthChange: _propTypes.default.func,
  /** Pass a function to closeDetailedDay
   * If not provided, the close option won't be shown in the detailed day panel
   */
  closeDetailedDay: _propTypes.default.func,
  /** Pass the content to display
   * TODO : to be refactored
   */
  days: _propTypes.default.objectOf(_propTypes.default.shape({
    content: _propTypes.default.node,
    footer: _propTypes.default.node,
    indicator: _propTypes.default.node
  })),
  // A day selected for which we want to have more details it has the format YYYY-MM-DD
  detailedDay: _propTypes.default.string,
  // The details content
  detailedDayContent: _propTypes.default.node,
  // The map of year -> [0,1,..] to define which month can be chosen
  months: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.number)),
  // The details content
  monthDetails: _propTypes.default.node,
  /** element to display between month selection & calendar */
  additionalChild: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
cov_26134e7pkr().s[46]++;
Calendar.defaultProps = {
  month: new Date(),
  days: {},
  detailedDay: undefined,
  detailedDayContent: '',
  onMonthChange: undefined,
  months: undefined,
  closeDetailedDay: undefined,
  monthDetails: undefined,
  additionalChild: null
};
var _default = exports.default = Calendar;